import { createReducer, on } from '@ngrx/store';

import { NotificationFeedActions } from './notification-feed.actions';
import {
  initialNotificationFeedState,
  notificationFeedAdapter,
  NotificationFeedState,
} from './notification-feed.model';

export const NotificationFeedReducer = createReducer(
  initialNotificationFeedState,
  on(
    NotificationFeedActions.getUserNotificationsSuccess,
    (state, { resp, unreadStatusIndicator }): NotificationFeedState =>
      notificationFeedAdapter.setAll(resp.notifications, {
        ...state,
        unreadStatusIndicator,
        currentPage: 1,
        hasMore: resp.hasMore,
        isLoadingMore: false,
      })
  ),
  on(
    NotificationFeedActions.loadMoreNotifications,
    (state): NotificationFeedState => ({
      ...state,
      isLoadingMore: true,
    })
  ),
  on(
    NotificationFeedActions.loadMoreNotificationsSuccess,
    (state, { resp }): NotificationFeedState =>
      notificationFeedAdapter.addMany(resp.notifications, {
        ...state,
        currentPage: state.currentPage + 1,
        hasMore: resp.hasMore,
        isLoadingMore: false,
      })
  ),
  on(
    NotificationFeedActions.getUserNotificationsFailure,
    NotificationFeedActions.loadMoreNotificationsFailure,
    (state): NotificationFeedState => ({
      ...state,
      isLoadingMore: false,
    })
  ),
  on(
    NotificationFeedActions.open,
    (state): NotificationFeedState => ({
      ...state,
      unreadStatusIndicator: false,
    })
  ),
  on(
    NotificationFeedActions.open,
    (state): NotificationFeedState => ({
      ...state,
      unreadStatusIndicator: false,
    })
  ),
  on(
    NotificationFeedActions.markNotificationsAsRead,
    (state, { ids }): NotificationFeedState =>
      notificationFeedAdapter.updateMany(
        ids.map(id => ({ id, changes: { markedReadAt: new Date() } })),
        state
      )
  ),
  on(
    NotificationFeedActions.markNotificationAsUnread,
    (state, { id }): NotificationFeedState =>
      notificationFeedAdapter.updateOne({ id, changes: { markedReadAt: undefined } }, state)
  ),
  on(NotificationFeedActions.markAllAsRead, (state): NotificationFeedState => {
    const changes = { markedReadAt: new Date() };
    const updates = Object.keys(state.entities).map(id => ({ id, changes }));
    return notificationFeedAdapter.updateMany(updates, state);
  }),
  on(
    NotificationFeedActions.setFilterOption,
    (state, { filterBy }): NotificationFeedState =>
      notificationFeedAdapter.removeAll({
        ...state,
        filterBy,
        currentPage: 1, // reset to the first page whenever changing filter
        hasMore: true,
        isLoadingMore: true,
      })
  ),
  on(
    NotificationFeedActions.updateUnreadStatusIndicator,
    (state, { unreadStatusIndicator }): NotificationFeedState => ({
      ...state,
      unreadStatusIndicator,
    })
  )
);
